<script setup>
import { computed } from 'vue'
import Badge from '@/components/Badge.vue'
import { deriveRoleLabel, resolveTeamMember, teamRoleBadgeType, teamRoleKey } from '@/Utils/teamAccessSummary'

const props = defineProps({
	params: {
		type: Object,
		default: null,
	},
	member: {
		type: Object,
		default: null,
	},
})

const data = computed(() => resolveTeamMember(props))
// Display label may be a derived "Custom access" for moderators whose
// permissions diverge from the preset (backend role stays `moderator`).
const label = computed(() => deriveRoleLabel(data.value))
const roleKey = computed(() => teamRoleKey(data.value.role || data.value.permissions?.role))
// Roles are per workspace. Someone not on this workspace has none here.
const notHere = computed(() => data.value.onProject === false)
</script>

<template>
	<div class="flex items-center h-full w-fit max-w-full">
		<span v-if="notHere" class="text-tiny text-surface-6" title="No role in this workspace">None</span>
		<Badge v-else :type="teamRoleBadgeType(label)" pill size="sm" inline>
			{{ label }}
		</Badge>
	</div>
</template>
